import React from 'react';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import { useConvertToFormat } from 'src/components/dropdowns/hooks';
import { IRangeAndSet, IRangeAndSetData } from 'src/typings/filter';
import { useTranslations } from 'src/hooks/translataions';
import { AppComponentCheckbox } from 'src/components/AppCheckbox';
import { useStyles } from '../../styles';
import { useCheckboxState } from './useCheckboxState';

interface IAppCheckboxFilter {
  dropdownInfo: IRangeAndSet;
}

export const AppCheckboxMultiBoxInfrastructure: React.FC<IAppCheckboxFilter> = React.memo(({
  dropdownInfo,
}) => {
  const styles = useStyles({});
  const { getTranslations } = useTranslations();
  const { currentData } = useConvertToFormat(dropdownInfo.data, dropdownInfo.attribute, false);
  const {
    filterValue,
    handleSelectSingleCheckbox,
  } = useCheckboxState(dropdownInfo.attribute);

  return (
    <FormControl component="fieldset">
      <FormGroup>
        <FormLabel
          className={styles.titleItem}
          component="legend"
        >
          {`${getTranslations(dropdownInfo.attribute)}`}
        </FormLabel>
        <div className={styles.wrapperCheckboxes}>
          {currentData
            .map((item: IRangeAndSetData) => {
              return (
                <FormControlLabel
                  key={item.key}
                  className={styles.checkboxItem}
                  onClick={() => handleSelectSingleCheckbox(item)}
                  control={(
                    <AppComponentCheckbox
                      isChecked={filterValue.includes(item.value)}
                      label={item.value}
                    />
                )}
                  label=""
                />
              );
            })}
        </div>
      </FormGroup>
    </FormControl>
  );
});
